import { sepFormat } from 'utilities';
import type { OrderingDiagnostic } from './orderingDiagnostics';

export const discountContextLabels = {
  standard_discount: 'Standard',
  non_standard_discount: 'Non-standard',
  package_discount: 'Package',
} as const;

type Context = keyof typeof discountContextLabels;

export const discountPercentage = (value: string | null) => (value != null ? `${sepFormat(value)}%` : '—');

export function discountRuleLabel(rule: {
  target_activity: { name: string } | null;
  target_category: { name: string } | null;
}): string {
  const parts = [rule.target_activity?.name, rule.target_category?.name].filter(Boolean);
  return parts.length ? parts.join(' · ') : 'Any';
}

export function discountDiagnosticText(
  diagnostics: readonly OrderingDiagnostic<Context>[],
  visibleContexts: readonly Context[],
) {
  return diagnostics.flatMap((diagnostic) => {
    const affected = diagnostic.contexts.filter((context) => visibleContexts.includes(context));
    return affected.length
      ? [
          <div key={diagnostic.earlierRuleId}>
            {`Earlier rule #${diagnostic.earlierRuleId} also applies to ${affected.map((context) => discountContextLabels[context]).join(', ')}.`}
          </div>,
        ]
      : [];
  });
}
